import { ChangeEvent, useState } from "react";
import AppBar from "../components/AppBar";
import CustomButton from "../components/CustomButton";
import CustomInput from "../components/CustomInput";
import CustomRadioButton from "../components/CustomRadioButton";
import Modals from "../components/Modal";
import { toast } from "react-toastify";
import { ParseErrors } from "../utils/ParseErrors";
import axiosInstance from "../utils/axiosInstance";
import { useNavigate } from "react-router-dom";
import { useDebounceCallback } from "usehooks-ts";
import GetUser from "../utils/getUser";

export default function AddInsurer() {
  const currentUser = GetUser()
  const [values, setValues] = useState<Record<string, any>>({})
  const [loading, setLoading] = useState<boolean>(false)
  const navigate = useNavigate()

  if (currentUser?.type !== "super-admin") {
    navigate("/")
  }

  // ------------------------------- [ CREATE PROVIDERS ] -------------------------------

  const createProvider = async () => {
    if (ValidateValues()) {
      setLoading(true)
      try {
        const res = await axiosInstance.post("/provider/create", values)
        toast.success(res.data.message)
        setLoading(false)
        navigate("/providers")
      } catch (error) {
        toast.error(ParseErrors(error))
        setLoading(false)
      }
    }
  }


  // ------------------------------ [ VALIDATE FUNCTION ] ---------------------------------
  const ValidateValues = () => {
    if (!values.name) {
      toast.error("Please Enter Provider Name")
      return false
    } else if (!values.email) {
      toast.error("Please Enter Provider Email")
      return false
    } else if (!values.type) {
      toast.error("Please Select Provider Type")
      return false
    } else if (!values.product) {
      toast.error("Please Select Provider Product")
      return false
    } else {
      return true
    }
  }


  // ----------------------------- [ UPDATE VALUES ] ---------------------------------------

  const HandleChangeValues = useDebounceCallback((e: ChangeEvent<HTMLInputElement>) => {
    setValues((prev) => ({ ...prev, [e.target.name]: e.target.value }))
  }, 200)

  return (
    <>
      <div className="sticky top-0 z-20">
        <AppBar title="DocuSure" profileInfo />
      </div>

      <Modals
        showDialog={true}
        onCloseDialog={() => console.log("e")}
        title="Add Insurer"
        width="660"
        centerTitle
        backButton
      >
        <div className="mx-5 mt-12 smallTablet:mx-4 smallTablet:mt-6">
          <div className="my-7 flex gap-x-12 smallTablet:flex-col smallTablet:gap-y-4 smallTablet:my-4">
            <CustomInput
              label="Insurer Name"
              autoComplete="none"
              defaultValue={values?.name}
              name="name"
              onChange={HandleChangeValues}
            ></CustomInput>

            <CustomInput
              label="Email Address"
              autoComplete="none"
              defaultValue={values?.email}
              name="email"
              onChange={HandleChangeValues}
            ></CustomInput>

          </div>
          <div className="my-5 flex gap-x-12 smallTablet:flex-col smallTablet:gap-y-4 smallTablet:my-4">


            <div className="w-1/2 smallTablet:w-full">
              <CustomInput
                label="Scheme Code"
                autoComplete="none"
                defaultValue={values?.schemeCode}
                name="schemeCode"
                onChange={HandleChangeValues}
              ></CustomInput>
            </div>

            <div className="w-1/2 smallTablet:w-full">
              <CustomInput
                label="Product Type"
                autoComplete="none"
                defaultValue={values?.productType}
                name="productType"
                onChange={HandleChangeValues}
              ></CustomInput>
            </div>
          </div>

          <div className="my-5 flex gap-x-12 smallTablet:flex-col smallTablet:gap-y-4 smallTablet:my-4">
            <div className="w-1/2 smallTablet:w-full">
              <label className="text-label-muted mt-6 smallTablet:mt-2 mb-2 font-medium block text-sm leading-[16.98px]">
                Type
              </label>
              <div className="flex gap-5 smallTablet:flex-wrap smallTablet:gap-3">
                <CustomRadioButton
                  id="option1"
                  name="type"
                  label="Sales"
                  checked={values?.type === "Sales"}
                  onChange={HandleChangeValues}
                  value="Sales"
                />
                <CustomRadioButton
                  id="option2"
                  name="type"
                  label="Renewals"
                  value="Renewals"
                  checked={values?.type === "Renewals"}
                  onChange={HandleChangeValues}
                />
              </div>
            </div>

            <div className="w-1/2 smallTablet:w-full">
              <label className="mt-6 smallTablet:mt-2 mb-2 text-label-muted font-medium block text-sm leading-[16.98px]">
                Product
              </label>
              <div className="flex gap-5 w-1/2 smallTablet:w-full smallTablet:flex-wrap smallTablet:gap-3">
                <CustomRadioButton
                  id="standard"
                  name="product"
                  label="Standard"
                  checked={values?.product === "Standard"}
                  onChange={HandleChangeValues}
                  value="Standard"
                />
                <CustomRadioButton
                  id="nonStandard"
                  name="product"
                  label="Non-Standard"
                  value="Non-Standard"
                  checked={values?.product === "Non-Standard"}
                  onChange={HandleChangeValues}
                />
              </div>
            </div>

          </div>

          <hr className="mx-2 my-5 border-edge-faint border-dashed" />
          <div className="pt-3 pb-6">
            <CustomButton fullWidth variant="primary" disabled={loading} onClick={createProvider}>
              ADD INSURER
            </CustomButton>
          </div>
        </div>
      </Modals>
    </>
  );
}
